import { Tracking } from '@panamax/app-state';
import { MyOrdersTracingMessages } from 'src/app/my-orders/tracking/tracing/my-orders-tracing.constants';
import { myOrdersCallTransformer } from '../my-orders-tracing.transformers';

export const myOrdersCallTrace: Tracking = {
  tracing: {
    data: {
      traceContext: MyOrdersTracingMessages.traceContext,
      isEndOfTrace: false,
      isStartOfTrace: true,
      attributes: {
        user: {
          id: '',
        },
        event: MyOrdersTracingMessages.myOrdersCall,
        watermark: '',
      },
    },
    transformFunc: myOrdersCallTransformer,
  },
};
